import axios from "axios";
import React, { useEffect, useState } from "react";
import { getId } from "../../../utils/getId";
import { urlMap } from "../utils/urlMap";
import { phaseLabelMap } from "../utils/medioTags";

export const useGetPlayersNominated = ({phase})=>{
    const [allPlayers, setAllPlayers] = useState([])
    const editionId = getId(3)

    
    useEffect(()=>{
        const url =  urlMap[phase];
        axios.get(url,{params:{
            "edition":editionId
        }}).then(res => {
            setAllPlayers(res?.data?.playersNominate)})
            .catch(e => console.log('error', e))

    },[editionId])

    return{
        allPlayers
    }

}